/* app/js/src/components/calendar/rename-show-modal.component.scss */
.cursor-pointer {
  cursor: pointer;
}
input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input.ng-invalid.ng-dirty[type=text],
input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-cancel,
.btn-rename {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-cancel:focus,
.btn-rename:focus {
  outline-color: #ffffff;
}
.btn-cancel:hover,
.btn-rename:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-cancel,
.disabled.btn-rename {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
:host {
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.title {
  font-family: "Open Sans";
  font-size: 20px;
  color: #232f3a;
  margin-bottom: 15px;
}
.label {
  font-family: "Open Sans";
  font-size: 12px;
  line-height: 30px;
  color: #93a9bf;
}
input[type=text] {
  width: 250px;
  height: 26px;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 7px;
  margin-right: 7px;
}
.input-container {
  display: flex;
  margin-bottom: 15px;
}
.btn-rename {
  width: 65px;
  margin-left: 15px;
  text-align: center;
}
.btn-cancel {
  width: 65px;
  color: #232f3a;
  background-color: #879baf;
  text-align: center;
}
.apply-cancel-container {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
/*# sourceMappingURL=rename-show-modal.component.css.map */
